import { render, staticRenderFns } from "./OrganizationalUnitBasicInfoForm.vue?vue&type=template&id=24cce449&"
import script from "./OrganizationalUnitBasicInfoForm.vue?vue&type=script&lang=js&"
export * from "./OrganizationalUnitBasicInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OrganizationalUnitBasicInfoForm.vue"
export default component.exports